import { SbirYear } from './sbir-year.model';
import { SbirReceipt } from './sbir-receipt.model';
import { SbirAward } from './sbir-award.model';

export class SbirCalculation {
  year: SbirYear;
  receipts: SbirReceipt[];
  awards: SbirAward[];

  constructor(taxCreditCalculation?: any) {
    if (taxCreditCalculation) {
      Object.assign(this, taxCreditCalculation);
    }
  }
}
